import Hero from "./components/Hero";
import Mission from "./components/Mission";
import CompanyValues from "./components/CompanyValues";
import SEOMeta from "../../components/SEOMeta";
import { WebPaths } from "../../../../routes/data";
import { SVLogoSquare } from "../../../../images";

const About = () => {
  return (
    <>
      <SEOMeta
        title="About Us | SeamlessVisa"
        description="Learn more about our mission, values, and team. We are a team of lawyers, engineers, and entrepreneurs who are passionate about helping people get the best possible immigration experience."
        canonicalUrl={`https://www.seamlessvisa.com${WebPaths.About}`}
        url={`https://www.seamlessvisa.com${WebPaths.About}`}
        siteName="SeamlessVisa"
        publisher="https://www.facebook.com/share/1BhLA5r2Ac/"
        imageUrl={SVLogoSquare}
        imageWidth="1920"
        imageHeight="1080"
        imageType="image/png"
        twitterCard="summary_large_image"
        twitterTitle="About Us | SeamlessVisa"
        twitterDescription="Learn more about our mission, values, and team. We are a team of lawyers, engineers, and entrepreneurs who are passionate about helping people get the best possible immigration experience."
        twitterSite="@SeamlessVisa_"
      />
      <div className="relative overflow-hidden bg-white-f9">
        <Hero />
        <Mission />
        <CompanyValues />
      </div>
    </>
  );
};

export default About;
